import { Dayjs } from 'dayjs';

export enum TaskStatus {
  ERROR = 'error',
  COMPLETED = 'completed',
  PENDING = 'pending',
}

export enum Schedule {
  NOW = 'now',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  HOURLY = 'hourly',
  EVERY_MINUTE = 'every_minute',
  CUSTOM_TIME = 'custom_time',
}

export type Task = {
  date: string;
  id: number;
  instruction: string;
  schedule: Schedule;
  status: TaskStatus;
  agent_name: string;
  result_count: number;
  schedule_at: ScheduleAt;
  error?: {
    errorMessage: string;
  };
};

export interface ScheduleAt {
  weekday_number?: number | null;
  schedule_time?: Dayjs | null;
  month_day?: number | null;
}

export interface Instruction {
  instruction: string;
  schedule: Schedule;
  agentId: number | string;
  instructionName: string;
  scheduleAt: ScheduleAt;
}
